
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.5 25.2h-21a1.735 1.735 0 01-1.748-1.717L1 13.166a1.735 1.735 0 011.748-1.718h24.5A1.735 1.735 0 0129 13.166l-1.748 10.315A1.735 1.735 0 0125.5 25.2zM5.376 14.312a.861.861 0 100 1.721h19.252a.861.861 0 100-1.721zm21.872-4.584H2.752V5.717A1.735 1.735 0 014.5 4h8.752A1.735 1.735 0 0115 5.717h10.5a1.734 1.734 0 011.748 1.716v2.294z","fill":"#222"}})])
          )
        }
      }
    